var recentlyViewedInterval = setInterval(function () {
  const containers = document.querySelectorAll('[data-recently-viewed-main]');
  if (containers.length === 0) return;
  containers.forEach(function (container) {
    // Skip if already initialized
    if (container.dataset.swiperInitialized === 'true') return;
    const swiperContainer = container.querySelector('[data-recently-viewed-container]');
    const currentSlideEl = container.querySelector('[data-current-slide]');
    const totalSlidesEl = container.querySelector('[data-total-slides]');
    const nextEl = container.querySelector('[data-recently-viewed-next]');
    const prevEl = container.querySelector('[data-recently-viewed-prev]');
    new Swiper(swiperContainer, {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      on: {
        init: function () {
          const total = this.slides.length;
          if (totalSlidesEl) totalSlidesEl.textContent = total;
          if (currentSlideEl) currentSlideEl.textContent = this.realIndex + 1;
        },
        slideChange: function () {
          if (currentSlideEl) currentSlideEl.textContent = this.realIndex + 1;
        }
      }
    });
    container.dataset.swiperInitialized = 'true';
  });
}, 500);
